module.exports = __webpack_public_path__ + "static/landing-video-01b94bfbd05a6549887de83e5d7ee334.mp4";